
import { NgModule , ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';

import { AppSettingsService } from './appsettings.service';



@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule
  ],
  declarations: [   
    
  ],
  entryComponents: []
  ,
  exports: [    

  ]
  ,providers: [
    AppSettingsService
    ],
})
export class AppServicesModule { 
  static forRoot(): ModuleWithProviders<AppServicesModule> {
    return {
      ngModule: AppServicesModule,
      providers: []
    }
  }
}